import { render, staticRenderFns } from "./SampleSelect.vue?vue&type=template&id=24e13e67&scoped=true"
import script from "./SampleSelect.vue?vue&type=script&lang=js"
export * from "./SampleSelect.vue?vue&type=script&lang=js"
import style0 from "./SampleSelect.vue?vue&type=style&index=0&id=24e13e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e13e67",
  null
  
)

export default component.exports